<template>
  <div class="array-checkbox custom-control custom-control-inline custom-checkbox" @click="addToBasket">
    <input v-model="checked" class="custom-control-input" type="checkbox" :value="val" :disabled="disable">
    <label :class="['custom-control-label', {'pulse': displayAnimation}]">
      <span>
        {{ label }}
      </span>
    </label>
  </div>
</template>

<script>
import {FIRST_BULK_BUY} from "@/store/mutation-types";

export default {
  name: "ArrayCheckbox",
  props: ['value', 'val', 'label', 'limit', 'disabled'],
  data() {
    return {
      checkedProxy: false,
      displayCheckAnimation: true,
    }
  },
  computed: {
    checked: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.checkedProxy = val
        this.$emit('input', this.checkedProxy)
      }
    },
    disable: function() {
      return (this.limit && this.limit<=this.value.length && !this.isValueChecked) || this.disabled;
    },
    isValueChecked: function () {
      return (this.checked.find((item) => item[0].id === this.val[0].id) !== undefined);
    },
    isFirstBulkBuy: {
      get: function () {
        return this.$store.state.FIRST_BULK_BUY;
      },
      set: function (value) {
        this.$store.commit(FIRST_BULK_BUY, value);
      }
    },
    displayAnimation: function () {
      if (this.isFirstBulkBuy !== undefined) {
        return this.isFirstBulkBuy && !this.disable;
      }
      return this.displayCheckAnimation && !this.disable;
    }
  },
  methods: {
    addToBasket: function () {
      this.isFirstBulkBuy = false;
      this.displayCheckAnimation = false;
    }
  }
}
</script>

<style scoped>

</style>
